'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var debug = require('debug')('thor:injector');

var web3Utils = require('web3-utils');

var utils = require("../utils");

var extendFormatters = function extendFormatters(web3) {
  var outputTransactionFormatter = web3.extend.formatters.outputTransactionFormatter;

  web3.extend.formatters.outputTransactionFormatter = function (tx) {
    if (tx && tx.isThorified) {
      debug('outputTransactionFormatter');
      tx.chainTag = web3Utils.numberToHex(tx.chainTag);

      if (tx.clauses) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = tx.clauses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var clause = _step.value;
            clause.value = web3.extend.formatters.outputBigNumberFormatter(clause.value);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return tx;
    } else {
      return outputTransactionFormatter(tx);
    }
  };

  var outputTransactionReceiptFormatter = web3.extend.formatters.outputTransactionReceiptFormatter;

  web3.extend.formatters.outputTransactionReceiptFormatter = function (receipt) {
    if (receipt && receipt.isThorified) {
      debug('outputTransactionReceiptFormatter');

      if (receipt.hasOwnProperty('transactionIndex')) {
        delete receipt.transactionIndex;
      }

      if (receipt.hasOwnProperty('cumulativeGasUsed')) {
        delete receipt.cumulativeGasUsed;
      }

      receipt.gasUsed = web3Utils.hexToNumber(receipt.gasUsed);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = receipt.outputs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var output = _step2.value;

          if (web3Utils._.isArray(output.events)) {
            output.events = output.events.map(function (event) {
              if (!event.isThorified) {
                Object.defineProperty(event, 'isThorified', {
                  get: function get() {
                    return true;
                  }
                });
              }

              return web3.extend.formatters.outputLogFormatter(event);
            });
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return receipt;
    } else {
      return outputTransactionReceiptFormatter(receipt);
    }
  };

  var outputLogFormatter = web3.extend.formatters.outputLogFormatter;

  web3.extend.formatters.outputLogFormatter = function (log) {
    if (log && log.isThorified) {
      debug('outputLogFormatter');

      if (log.hasOwnProperty('transactionIndex')) {
        delete log.transactionIndex;
      }

      if (log.hasOwnProperty('logIndex')) {
        delete log.logIndex;
      }

      if (log.hasOwnProperty('id')) {
        delete log.id;
      }

      return log;
    } else {
      return outputLogFormatter(log);
    }
  };
};

exports.extendFormatters = extendFormatters;

var inputLogFilterFormatter = function inputLogFilterFormatter(options) {
  if (options) {
    var logFilterOptions = {};

    if (options.address) {
      logFilterOptions.address = utils.validAddressOrError(options.address);
    }

    if (options.pos) {
      logFilterOptions.pos = utils.validBytes32OrError(options.pos, 'Invalid position(block ID)');
    }

    if (options.t0) {
      logFilterOptions.t0 = utils.validBytes32OrError(options.t0, 'Invalid t0');
    }

    if (options.t1) {
      logFilterOptions.t1 = utils.validBytes32OrError(options.t1, 'Invalid t1');
    }

    if (options.t2) {
      logFilterOptions.t2 = utils.validBytes32OrError(options.t2, 'Invalid t2');
    }

    if (options.t3) {
      logFilterOptions.t3 = utils.validBytes32OrError(options.t3, 'Invalid t3');
    }

    if (options.t4) {
      logFilterOptions.t4 = utils.validBytes32OrError(options.t4, 'Invalid t4');
    }

    return logFilterOptions;
  }
};

exports.inputLogFilterFormatter = inputLogFilterFormatter;

var inputBlockFilterFormatter = function inputBlockFilterFormatter(blockID) {
  if (blockID) {
    blockID = utils.validBytes32OrError(blockID, 'Invalid position(block ID)');
    return blockID;
  }
};

exports.inputBlockFilterFormatter = inputBlockFilterFormatter;

var inputTransferFilterFormatter = function inputTransferFilterFormatter(options) {
  if (options) {
    var transferFilterOptions = {};

    if (options.pos) {
      transferFilterOptions.pos = utils.validBytes32OrError(options.pos, 'Invalid position(block ID)');
    }

    if (options.txOrigin) {
      transferFilterOptions.txOrigin = utils.validAddressOrError(options.txOrigin);
    }

    if (options.sender) {
      transferFilterOptions.sender = utils.validAddressOrError(options.sender);
    }

    if (options.recipient) {
      transferFilterOptions.recipient = utils.validAddressOrError(options.recipient);
    }

    return transferFilterOptions;
  }
};

exports.inputTransferFilterFormatter = inputTransferFilterFormatter;